export enum Keys {
  UP = 38,
  DOWN = 40,
  RIGHT = 39,
  LEFT = 37,
  ENTER = 13,
  ESC = 27,
  PLUS = 43,
  A = 65,
  Z = 90,
  SPACE = 32
}



// WEBPACK FOOTER //
// ./src/enums.ts